import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { isEmptyArray } from '@vista-digital/occ-domain';
import { observer } from 'mobx-react';
import { useI18n } from '../../../context/occ/hooks/use-i18n';
import { TagColor } from '../../../subcomponents/tag/types/color';
import { TagStyle } from '../../../subcomponents/tag/types/style';
import { TagList } from '../../../subcomponents/tag-list/tag-list';
const b = bemClassBuilder('v-site-picker-selected-site-list');
export const SitePickerSelectedSiteList = observer(props => {
    const i18n = useI18n();
    const { sites, onSiteClicked, removeSelectedSiteIconName } = props;
    if (isEmptyArray(sites))
        return null;
    const mapSiteToTagProps = (site) => {
        return {
            id: site.id,
            label: i18n.translatable(site.name),
            buttonIconName: removeSelectedSiteIconName,
            style: TagStyle.Block,
            color: TagColor.Secondary
        };
    };
    const getTags = () => {
        return sites.map(mapSiteToTagProps).sort((a, c) => {
            if (!a.label || !c.label)
                return 0;
            if (a.label < c.label) {
                return -1;
            }
            if (a.label > c.label) {
                return 1;
            }
            return 0;
        });
    };
    return (_jsx("div", { className: b.block(), children: _jsx(TagList, { tags: getTags(), onTagClicked: onSiteClicked }) }));
});
SitePickerSelectedSiteList.displayName = 'SitePickerSelectedSiteList';
//# sourceMappingURL=selected-site-list.js.map